import React from 'react'
import ReturnHeader from '../../components/returnHeader'

const index = () => {
  return (
    <div><ReturnHeader page={'Post yaratish'} dots={true}/></div>
  )
}

export default index